import React from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import "./components/dashboard/components/menu/HamburgerMenu.css";
import Footer from "./components/Footer";

import ScrollToTop from "./utils/ScrollToTop";
import Navbar from "./components/Navbar";
import { CompanyDetailsProvider } from "./context/CompanyDetailsProvider";
import { HamburgerMenuContextProvider } from "./components/dashboard/store/HamburgerMenuContextProvider";
import { SeasonContextProvider } from "./components/dashboard/store/SeasonContextProvider";
import { ModalContextProvider } from "./components/dashboard/store/ModalContextProvider";
import { PickupLocationContextProvider } from "./components/dashboard/store/PickupLocationContextProvider";
import { SubscriptionsContextProvider } from "./components/dashboard/store/SubscriptionsContextProvider";
import { UserPickupContextProvider } from "./components/dashboard/store/UserPickupContextProvider";
import AppRoutes from "./components/AppRoutes";

const App: React.FC = () => {
  const { pathname } = useLocation();
  const isDashboard = pathname.startsWith("/dashboard");
  const pageClass = pathname.split("/").filter(Boolean)[0] || "home";

  return (
    <CompanyDetailsProvider>
      <SeasonContextProvider>
        <SubscriptionsContextProvider>
          <PickupLocationContextProvider>
            <UserPickupContextProvider>
              <ModalContextProvider>
                <HamburgerMenuContextProvider>
                  <div className={`App ${pageClass}`}>
                    {!isDashboard && (
                      <>
                        <Navbar />
                      </>
                    )}
                    <div className="content-container-wrapper">
                      <ScrollToTop />
                      <AppRoutes />
                    </div>
                    {!isDashboard && <Footer />}
                  </div>
                </HamburgerMenuContextProvider>
              </ModalContextProvider>
            </UserPickupContextProvider>
          </PickupLocationContextProvider>
        </SubscriptionsContextProvider>
      </SeasonContextProvider>
    </CompanyDetailsProvider>
  );
};

export default App;
